var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.678 7.15h4.95a.602.602 0 01.6.644V12.7c0 .33-.27.6-.6.6-.33 0-.6-.27-.6-.6V9.203l-5.81 5.827c-.005.005-.01.008-.015.01-.005.003-.01.005-.015.01-.01 0-.01.01-.01.01-.01.01-.03.02-.05.03a.45.45 0 01-.14.1c-.01.005-.017.005-.025.005-.007 0-.015 0-.025.005-.06.02-.12.04-.18.04a.58.58 0 01-.44-.19l-3.81-3.82-5.46 5.44c-.11.12-.27.18-.42.18-.15 0-.31-.06-.42-.17a.61.61 0 010-.85L9.038 10a.108.108 0 00.018-.025c.006-.01.01-.02.022-.025a.61.61 0 01.85 0l3.82 3.84 5.432-5.44h-3.502c-.33 0-.6-.27-.6-.6 0-.33.27-.6.6-.6z"
  })));
}

export default SvgGoingUp;